import '../styles/pages/ContactPage.css';
import { m } from 'framer-motion';
import { fadeUp, staggerContainer, staggerItem, viewport } from '../motion/variants';

const HERO_IMAGE = '/img/abl10.jpeg';
const PHONE = '+255625313162';
const PHONE_DISPLAY = '+255 625 313 162';
const EMAIL = 'info@ablconstruction.co.tz';
const MAP_EMBED_SRC =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15847.848933300318!2d39.20208334922793!3d-6.774451360452163!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x185c4e9233cc0ea9%3A0x5203154c70c291e1!2sMlimani%20Tower!5e0!3m2!1sen!2stz!4v1779241875865!5m2!1sen!2stz';

function IconPhone() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path
        fill="currentColor"
        d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
      />
    </svg>
  );
}

function IconMail() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
      />
    </svg>
  );
}

function IconLocation() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
      />
    </svg>
  );
}

function IconMailbox() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
      />
    </svg>
  );
}

const contactDetails = [
  {
    id: 'phone',
    icon: IconPhone,
    content: <a href={`tel:${PHONE}`}>{PHONE_DISPLAY}</a>,
  },
  {
    id: 'email',
    icon: IconMail,
    content: <a href={`mailto:${EMAIL}`}>{EMAIL}</a>,
  },
  {
    id: 'po-box',
    icon: IconMailbox,
    content: <span>P.O. Box 24614, Dar es Salaam</span>,
  },
  {
    id: 'office',
    icon: IconLocation,
    content: (
      <span>
        Mwenge Tower, 4th Floor — opposite Mlimani City, Sam Nujoma Road
      </span>
    ),
  },
];

function ContactPage() {
  return (
    <main className="contact-page" id="contacts">
      <section className="contact-hero" aria-labelledby="contact-hero-heading">
        <img
          className="contact-hero-image"
          src={HERO_IMAGE}
          alt=""
          loading="eager"
          decoding="async"
        />
        <div className="contact-hero-inner">
          <m.h1
            id="contact-hero-heading"
            className="contact-hero-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          >
            Get In Touch
          </m.h1>
          <m.p
            className="contact-hero-lead"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
          >
            Have a project inquiry or need reliable construction materials and transport services?
            Contact ABL Construction Limited today — our team is ready to assist you with
            professional and timely support.
          </m.p>
        </div>
      </section>

      <section className="contact-body" aria-labelledby="contact-info-heading">
        <div className="contact-body-inner">
          <div className="contact-grid">
            <m.article
              className="contact-info-card"
              initial="hidden"
              whileInView="visible"
              viewport={viewport}
              variants={staggerContainer}
            >
              <m.h2 id="contact-info-heading" variants={staggerItem}>
                Contact Information
              </m.h2>
              <m.ul className="contact-detail-list" variants={staggerItem}>
                {contactDetails.map(({ id, icon: Icon, content }) => (
                  <li key={id} className="contact-detail-item">
                    <span className="contact-detail-icon" aria-hidden="true">
                      <Icon />
                    </span>
                    <div className="contact-detail-value">{content}</div>
                  </li>
                ))}
              </m.ul>
            </m.article>

            <m.div
              className="contact-map-wrap"
              initial="hidden"
              whileInView="visible"
              viewport={viewport}
              variants={fadeUp}
            >
              <h2 className="contact-map-heading">Our location</h2>
              <div className="contact-map">
                <iframe
                  title="ABL Construction office location on Google Maps"
                  src={MAP_EMBED_SRC}
                  width="600"
                  height="450"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </m.div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default ContactPage;
